import {useQuery} from '@apollo/client';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {GET_ALL_ANNOUNCEMENTS} from 'graphql/queries/announcement';
import {makeSelectTabOperations} from 'redux/store/auth';
import {NavTabsEnum} from 'utils/constants';
import {AnnouncementsList} from '../components/AnnouncementsList';

const UpcomingAnnouncements = () => {
  const operations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Announcements),
  );

  const {data, loading, refetch} = useQuery(GET_ALL_ANNOUNCEMENTS, {
    variables: {type: 'UPCOMING'},
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  return (
    <AnnouncementsList
      status="upcoming"
      loading={loading}
      refetch={refetch}
      operations={operations}
      announcements={data?.getAllAnnouncements?.announcement || []}
    />
  );
};

export {UpcomingAnnouncements};
